import { useLocation, useNavigate } from "react-router";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import TabletsTable from "../components/Tablets/Table";
import { useAuth } from "../context/AuthContext";
import { terminalCreateError } from "../utils/useNotification";
import PlusIcon from "../components/common/Icons/PlusIcon";

const Tablets = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { company } = useAuth();

  return (
    <Container>
      <PageHeader
        pageTitle="Tabletler"
        isButtoned
        buttonIcon={<PlusIcon />}
        buttonText="Yeni Tablet"
        buttonOnClick={() => {
          if (company?.terminalPhoto) {
            navigate(`${location.pathname}/new`);
          } else {
            terminalCreateError();
          }
        }}
      />
      <TabletsTable />
    </Container>
  );
};

export default Tablets;
